import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import api from "@/lib/api";

export default function PromoBanner() {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/promotions").then((r) => setPromo(r.data[0] || null)).catch(() => {});
  }, []);

  if (!promo || dismissed) return null;
  return (
    <div data-testid="promo-banner" className="fixed inset-x-0 top-16 z-40 border-b border-[#D4AF37]/25 bg-[#D4AF37]/10 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2.5 sm:px-8">
        <p className="flex items-center gap-2 text-xs text-[#D4AF37] sm:text-sm">
          <Sparkles className="h-4 w-4 shrink-0" />
          <span>
            <strong className="font-semibold">{promo.title}</strong>
            {promo.description ? ` — ${promo.description}` : ""}
          </span>
        </p>
        <button data-testid="promo-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss offer" className="text-[#D4AF37]/70 transition-colors hover:text-[#D4AF37]">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
